<script lang="ts">
  import type { ProgressStepContext } from "@kontextwerk/web-sdk/ui/navigation/ProgressSteps.svelte"
  import type { DemoDataResetMembershipCandidate } from "../../../../../../../../../../../../../../api/kehrblatt/demo-data"
  import type { DemoResetMemberOutput } from "../../_shared/_logic/demo-data-reset-contract"
  import DemoMemberStep from "../../_shared/_modules/demo-member-step"

  const {
    ctx,
    candidates,
    primaryMembershipId,
    initialMembershipId = null,
    output = null,
    onOutput,
    onEdit,
  }: {
    ctx: ProgressStepContext
    candidates: readonly DemoDataResetMembershipCandidate[]
    primaryMembershipId: string
    initialMembershipId?: string | null
    output?: DemoResetMemberOutput | null
    onOutput: (output: DemoResetMemberOutput) => void
    onEdit: () => void
  } = $props()
</script>

<DemoMemberStep
  {ctx}
  role="secondary"
  title="Geselle auswählen"
  description="Wählen Sie ein zweites bestehendes Mitglied, das im Testzugang als Geselle auftritt."
  helpModalTextId="organizationTestDataGeselle"
  actionBoxLabel="Mitglied für den Gesellen"
  roleDescription="Der Geselle betreut die zweite Hälfte der Beispiel-Liegenschaften. Zugang, Rolle und Passwort des Mitglieds bleiben unverändert."
  emptyMessage="Für den Gesellen wird ein zweites aktives Mitglied benötigt. Laden Sie dazu zunächst ein weiteres Mitglied in die Organisation ein."
  {candidates}
  {initialMembershipId}
  excludedMembershipId={primaryMembershipId}
  {output}
  {onOutput}
  {onEdit}
/>
